import React, { useContext, useEffect, useState } from "react";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import styles from "./Step.module.css";
import { PatchApi, PostApi, getApi } from "../../../Utility/network";
import { useLocation, useNavigate } from "react-router-dom";
import CustomCheckBoxService from "../../../Components/CustomCheckBoxService/CustomCheckBoxService";
import info from "../../../assets/componentAssets/info.svg";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import {
  validateEmail,
  validateGermanPhoneNumber,
  validateGermanVAT,
  validatePostalCode,
} from "../utility/validations";
import billing from "../../../assets/componentAssets/billing.svg";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import { consumCertEngText } from "../../../Utility/engLangObject";
import { consumCertGerText } from "../../../Utility/gerLangObject";
import { selectedLanguage } from "../../../Utility/helper";

function Step8({ showForm = false, props }) {
  const style = { width: "100%" };
  const location = useLocation();
  const navigate = useNavigate();
  const [breakdown, setBreakDown] = useState({
    sub_total: null,
    total: null,
    add_on_service: [],
  });
  const [checked, setChecked] = useState({ check: false });
  const [response, setResponse] = useState(false);

  const { state, setState } = useContext(AppContext);
  const { Services } = state.needData;

  const { language, needLanguage } = state;
  const { address } = state.needData;
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState([]);
  const [services, setServices] = useState([]);
  const [pop, setPop] = useState(false);
  const [infoText, setInfoText] = useState([]);
  const [url, setUrl] = useState("");
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({
    order_type: 1,
    first_name: "",
    last_name: "",
    phone: null,
    postcode: null,
    location: "",
    email: "",
    company_name: "",
    vat_id: "",
    street: "",
  });
  const [isCertificate, setIsCertificate] = useState(false);
  const [packages, setPackages] = useState([]);
  const [selectedPackageIds, setSelectedPackageIds] = useState([]);

  const getPackageIdsFromReviewData = (reviewData) => {
    if (!reviewData) return [];

    try {
      const parsed =
        typeof reviewData === "string" ? JSON.parse(reviewData) : reviewData;
      if (!Array.isArray(parsed?.selected_packages)) {
        return [];
      }

      return parsed.selected_packages
        .map((pkg) => Number(pkg))
        .filter((pkg) => !Number.isNaN(pkg));
    } catch (error) {
      console.error("Error parsing package review data:", error);
      return [];
    }
  };

  const getPackageIdsFromAdditionalInfoList = (list) => {
    if (!Array.isArray(list)) return [];

    for (const item of list) {
      const packageIds = getPackageIdsFromReviewData(item?.review_data);
      if (packageIds.length > 0) {
        return packageIds;
      }
    }

    return [];
  };
  useEffect(() => {
    const isConsumptionCertificate = location.pathname.includes("/form/");
    setIsCertificate(isConsumptionCertificate);
  }, [location]);
  useEffect(() => {
    const { billing_address } = state.needData;
    setData(billing_address);
  }, [state.needData.billing_address]);
  useEffect(() => {
    getServices();
    getPackages();
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if (!state?.needId) return;
    getbreakDown();
    getNeedDetails();
  }, [state?.needId]);

  useEffect(() => {
    const { billing_address, buildingData } = state.needData;
    if (billing_address) {
      setData((prev) => {
        const { postcode, street, location, email, phone } = prev;
        let post = postcode
          ? postcode
          : billing_address?.postcode
            ? billing_address?.postcode
            : address?.postcode;
        let loc = location
          ? location
          : billing_address?.location
            ? billing_address?.location
            : address?.location;
        let streetHouse = street
          ? street
          : billing_address?.street
            ? billing_address?.street
            : address?.street;
        let _phone = phone ? phone : billing_address?.phone;
        let emailId = email
          ? email
          : billing_address?.email
            ? billing_address?.email
            : buildingData?.email;

        return {
          ...billing_address,
          postcode: post,
          location: loc,
          street: streetHouse,
          email: emailId,
          company_name: billing_address.company_name,
          vat_id: billing_address.vat_id,
          first_name: billing_address.first_name,
          last_name: billing_address.last_name,
          phone: _phone,
        };
      });
    }
  }, [state.otherData]);

  const getServices = async () => {
    try {
      const responseData = await getApi(`energy_consumption/add_on_services`);
      let data = responseData?.data;
      if (data?.data) data = data.data;
      else if (data?.results) data = data.results;

      if (Array.isArray(data)) {
        setServices(data);
      }
    } catch (error) { }
  };

  const getPackages = async () => {
    try {
      const responseData = await getApi(`payment/packages/`);

      let data = responseData.data;
      if (data && data.results) {
        data = data.results;
      } else if (data && data.data) {
        // Handle potential wrapper like { data: [...] }
        data = data.data;
      }

      const mappedData = (Array.isArray(data) ? data : []).map(pkg => ({
        ...pkg,
        amount: pkg.total_price // Map total_price to amount for CustomCheckBoxService
      }));
      setPackages(mappedData);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  const getNeedDetails = async () => {
    try {
      const responseData = await getApi(`energy_need/${state.needId}/`);
      if (responseData.status === 200) {
        const packages = responseData?.data?.data?.certificate_packages || [];
        const packageIds = packages
          .map((pkg) => Number(pkg.id || pkg))
          .filter((pkg) => !Number.isNaN(pkg));

        if (packageIds.length > 0) {
          setSelectedPackageIds(packageIds);
          return;
        }
      }

      const additionalInfoResponse = await getApi(
        `/energy_need/additional_information?energy_need=${state.needId}`
      );
      const list =
        additionalInfoResponse?.data?.data || additionalInfoResponse?.data || [];
      const fallbackPackageIds = getPackageIdsFromAdditionalInfoList(list);
      setSelectedPackageIds(fallbackPackageIds);
    } catch (error) { }
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    const error = validateFields(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const validateFields = (name, value) => {
    let error = "";
    const fieldName = "";
    // formStep1.find((field) => field.name === name)?.title || name;
    switch (name) {
      case "email":
        error = validateEmail(value, needLanguage);
        break;
      case "postcode":
        error = validatePostalCode(value, needLanguage);
        break;
      case "first_name":
      case "last_name":
      case "company_name":
      case "location":
      case "street":
        error = validateRequiredField(value, fieldName, "");
        break;
      case "phone":
        error = validateGermanPhoneNumber(value, needLanguage);
        break;
      case "vat_id":
        error = validateGermanVAT(value);
        break;
      default:
        break;
    }
    return error;
  };

  const validateRequiredField = (value, fieldName, type) => {
    if (type === "phone") {
      if (!value) {
        return needLanguage.field_required_error;
      }
      if (/[-eE+]/.test(value)) {
        return needLanguage.invalid_data_error;
      }
      return "";
    } else {
      return value ? "" : needLanguage.field_required;
    }
  };

  const handleSubmit = async (num, type) => {
    // Handle backward navigation without validation or try-catch
    if (type === "prev") {
      setState((prev) => ({
        ...prev,
        needPage: prev.needPage - 1,
        needData: { ...prev.needData, billing_address: data },
      }));
      return;
    }

    try {
      if (type === "next") {
        try {
          const order_type = data?.order_type;
          const { company_name, vat_id, ...rest } = data;
          let newData = { ...rest };
          const { company_name: company, vat_id: vat, ...rests } = errors;
          let newError = { ...rests };
          if (order_type == 2) {
            newData = { ...newData, company_name, vat_id };
            newError = { ...newError, company_name: company, vat: vat_id };
          } else if (order_type == 3) {
            newData = { ...newData, company_name };
            newError = { ...newError, company_name: company };
          }

          const validateFields = (object) => {
            const errors = {};
            Object.keys(object).forEach((key) => {
              const value = object[key];
              // Check if the value is either an empty string or null
              if (value === "" || value === null) {
                errors[key] = needLanguage.common_error;
              }
            });
            return errors;
          };
          const errorss = validateFields(newData);
          if (Object.keys(errorss).length === 0) {
          } else {
            setErrors(errorss);
            return;
          }
          const postData = await PatchApi(`/energy_need/${state.needId}/`, {
            billing_address: newData,
          });
          if (postData.status === 200 || postData.status === 201) {
            // const postEnergy = await getApi(
            //   `energy_consumption/form/${state.needId}/calculate_energy_consumption/`
            // );
            const payData = await PostApi(`/payment/checkout/`, {
              energy_need_id: state.needId,
            });
            localStorage.setItem("purchase_id", payData.data.data.id);
            window.open(payData.data.data.gateway_url, "_blank").focus();
            setState((prev) => ({
              ...prev,
              needData: {
                heatingSystemsCount: null,
                hotSystemsCount: null,
                construction_year: null,
                floor_details: [],
                roof_detail: {},
                basement_detail: {},
                insulation_details: [],
                windowDimension: false,
                active: {},
                insulation: false,
                heating_systems: [],
                hot_water_systems: [],
                are_renewable_energy_used: false,
                do_u_have_solar_collector: false,
                unobstructed_collector_area: null,
                address: {
                  direction_point: null,
                  is_property_have_border_on_another_house: false,
                  location: "",
                  postcode: "",
                  street: "",
                },
                billing_address: {
                  order_type: 1,
                  first_name: "",
                  last_name: "",
                  phone: null,
                  postcode: null,
                  location: "",
                  email: "",
                  company_name: "",
                  vat_id: "",
                  street: "",
                },
              },
              page: 1,
              filledPage: 1,
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "save") {
        await getApi(`/energy_need/${state.needId}/generate_link/`);
        // navigate("/login");
        setResponse(true);
      }
    } catch (error) {
      alert("something went wrong");
    }
  };
  const getbreakDown = async () => {
    try {
      const responseData = await getApi(
        `energy_need/${state.needId}/breakdown`
      );
      setBreakDown(responseData.data.data);
    } catch (error) { }
  };
  useEffect(() => {
    const service_id = Services?.map((item) => item.service?.id);
    setSelected(service_id);
  }, [Services]);
  const handleCheckboxChange = async (checkedIds) => {
    // if (name === "ventilation_id") {
    //   setSubmitData((prev) => ({ ...prev, ventilation_id: checkedIds }));
    // }
    setSelected(checkedIds);
    const data = {
      service_id: checkedIds,
    };
    try {
      const responseData = await PatchApi(
        `energy_need/${state.needId}/add_on_services/`,
        data
      );
      if (
        responseData.status === 200 ||
        responseData.status === 201 ||
        responseData.status === 204
      ) {
        getbreakDown();
      }
    } catch (error) { }
  };
  const handlePackageChange = async (checkedIds) => {
    setSelectedPackageIds(checkedIds);
    const data = {
      certificate_packages: checkedIds,
    };
    try {
      const responseData = await PatchApi(`energy_need/${state.needId}/`, data);
      if (
        responseData.status === 200 ||
        responseData.status === 201 ||
        responseData.status === 204
      ) {
        getbreakDown();
      }
    } catch (error) { }
  };

  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const popData = {
    order: [
      {
        heading: needLanguage.order_type,
        para1: needLanguage.order_type_paragaraph,
      },
    ],
    postcode: [
      {
        heading: needLanguage.billing_house_number,
        para1: needLanguage.billing_house_number_para_1,
        para2: needLanguage.billing_house_number_para_2,
        para3: needLanguage.billing_house_number_para_3,
      },
    ],
    mail: [
      {
        heading: needLanguage.eMail,
        para1: needLanguage.eMail_para_1,
        para2: needLanguage.eMail_para_2,
      },
    ],
  };
  return (
    <>
      <div
        style={{
          marginTop: "40px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 0px 80px 0px",
          borderRadius: "15px",
          paddingBottom: "20px",
        }}
      >
        <StepsHeader
          image={billing}
          heading={needLanguage?.billing_delivery_address}
          secPara={needLanguage.provided_information}
        />
        <div className={styles.billingCon}>
          <div className={styles.order}>
            <div className={styles.fieldCom}>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {needLanguage.order_type}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.order)}
                  />
                </p>
                <FormControl>
                  <RadioGroup
                    name="order_type" // Name of the radio group
                    value={data?.order_type} // Bind the state value
                    onChange={handleChange} // Handle value changes
                  >
                    <div className={styles.Radio1}>
                      {orderType.map((item, index) => {
                        return (
                          <FormControlLabel
                            value={item.id}
                            control={<Radio />}
                            label={selectedLanguage(item, language)}
                          />
                        );
                      })}
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>{needLanguage.phone_number}</p>
                <TextField
                  style={style}
                  size="small"
                  name="phone"
                  value={data?.phone}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange} // Handle value changes
                  type="number"
                  error={errors?.phone}
                  helperText={errors?.phone}
                />
              </div>
              {data?.order_type != 1 && (
                <React.Fragment>
                  <div
                    className={styles.fields}
                    style={{
                      width: `${data?.order_type == 3 ? "100%" : "48%"}`,
                    }}
                  >
                    <p className={styles.fieldName}>
                      {needLanguage.company_name}
                    </p>
                    <TextField
                      size="small"
                      style={style}
                      value={data?.company_name}
                      onWheel={(e) => e.target.blur()}
                      name="company_name"
                      onChange={handleChange} // Handle value changes
                      error={errors?.company_name}
                      helperText={errors?.company_name}
                    />
                  </div>
                  {data?.order_type == 2 && (
                    <div className={styles.fields}>
                      <p className={styles.fieldName}>{needLanguage.VAT_ID}</p>
                      <TextField
                        size="small"
                        onWheel={(e) => e.target.blur()}
                        style={style}
                        value={data?.vat_id}
                        name="vat_id"
                        onChange={handleChange} // Handle value changes
                        error={errors?.vat_id}
                        helperText={errors?.vat_id}
                      />
                    </div>
                  )}
                </React.Fragment>
              )}
              <div className={styles.fields}>
                <p className={styles.fieldName}>{needLanguage.first_name}</p>
                <TextField
                  size="small"
                  onWheel={(e) => e.target.blur()}
                  style={style}
                  value={data?.first_name}
                  name="first_name"
                  onChange={handleChange} // Handle value changes
                  error={errors?.first_name}
                  helperText={errors?.first_name}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>{needLanguage.surname}</p>
                <TextField
                  size="small"
                  style={style}
                  onWheel={(e) => e.target.blur()}
                  name="last_name"
                  onChange={handleChange} // Handle value changes
                  value={data?.last_name}
                  error={errors?.last_name}
                  helperText={errors?.last_name}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {needLanguage.billing_house_number}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.postcode)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  name="street"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange} // Handle value changes
                  value={data?.street}
                  error={errors?.street}
                  helperText={errors?.street}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {needLanguage.postcode}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.postcode)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  name="postcode"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleChange} // Handle value changes
                  value={data?.postcode}
                  error={errors?.postcode}
                  helperText={errors?.postcode}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {needLanguage.location}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.postcode)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  onWheel={(e) => e.target.blur()}
                  name="location"
                  onChange={handleChange} // Handle value changes
                  value={data?.location}
                  error={errors?.location}
                  helperText={errors?.location}
                />
              </div>
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {needLanguage.eMail}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.mail)}
                  />
                </p>
                <TextField
                  size="small"
                  style={style}
                  onWheel={(e) => e.target.blur()}
                  name="email"
                  onChange={handleChange} // Handle value changes
                  value={data?.email}
                  error={errors?.email}
                  helperText={errors?.email}
                />
              </div>
            </div>
            <div>
              <div style={{ marginBottom: "20px" }}>
                <h3>{needLanguage.certificate_packages_title}</h3>
                <p>{needLanguage.certificate_packages_description}</p>
                {packages && packages.length > 0 && (
                  <CustomCheckBoxService
                    data={packages}
                    name="certificate_packages"
                    onCheckChange={handlePackageChange}
                    selectedValues={selectedPackageIds}
                  />
                )}
              </div>
              <h3>{needLanguage.add_on_services}</h3>
              <CustomCheckBoxService
                data={services}
                name="service_id"
                onCheckChange={handleCheckboxChange}
                selectedValues={selected}
              />
            </div>
          </div>
          {isCertificate && (
            <div className={styles.summary}>
              <div style={{ borderBottom: "1px solid #22A156" }}>
                <p
                  style={{
                    color: "#22A156",
                    fontWeight: "900",
                    fontSize: "22px",
                    textAlign: "center",
                  }}
                >
                  {needLanguage.order_summary}
                </p>
              </div>
              <div style={{ borderBottom: "1px solid #22A156" }}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ width: "80%" }}>
                    <p
                      style={{
                        marginBottom: "5px",
                        fontWeight: "900",
                        fontSize: "16px",
                      }}
                    >
                      <b>{needLanguage.energy_performance_text}</b>
                    </p>
                    <p
                      style={{
                        marginTop: "8px",
                        marginBottom: "8px",
                        fontSize: "14px",
                      }}
                    >
                      {needLanguage.certificate_residential_build}
                    </p>
                  </div>
                  <p
                    style={{
                      marginBottom: "5px",
                      fontWeight: "900",
                      fontSize: "16px",
                    }}
                  >
                    {breakdown.sub_total} &#8364;
                  </p>
                </div>
              </div>
              {breakdown.add_on_service.map((item, index) => {
                return (
                  <div style={{ borderBottom: "1px solid #22A156" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "80%" }}>
                        <p
                          style={{
                            marginBottom: "5px",
                            fontSize: "16px",
                            fontWeight: "900",
                          }}
                        >
                          <b>{selectedLanguage(item)}</b>
                        </p>
                        {/* <p
                      style={{
                        marginTop: "8px",
                        marginBottom: "8px",
                        fontSize: "14px",
                      }}
                    >
                      Consumption Certificate for Residential Buildings
                    </p> */}
                      </div>
                      <p
                        style={{
                          marginBottom: "5px",
                          fontWeight: "900",
                          fontSize: "16px",
                        }}
                      >
                        {item.amount} &#8364;
                      </p>
                    </div>
                  </div>
                );
              })}
              <div
                style={{
                  borderBottom: "1px solid #22A156",
                  margin: "10px 0px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ width: "30px" }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checked.check} // Reflect selected values
                            onChange={async () => {
                              const order_type = data?.order_type;
                              const { company_name, vat_id, ...rest } = data;
                              let newData = { ...rest };
                              const {
                                company_name: company,
                                vat_id: vat,
                                ...rests
                              } = errors;
                              let newError = { ...rests };
                              if (order_type == 2) {
                                newData = { ...newData, company_name, vat_id };
                                newError = {
                                  ...newError,
                                  company_name: company,
                                  vat: vat_id,
                                };
                              } else if (order_type == 3) {
                                newData = { ...newData, company_name };
                                newError = {
                                  ...newError,
                                  company_name: company,
                                };
                              }

                              const validateFields = (object) => {
                                const errors = {};
                                Object.keys(object).forEach((key) => {
                                  const value = object[key];
                                  // Check if the value is either an empty string or null
                                  if (value === "" || value === null) {
                                    errors[key] = needLanguage.common_error;
                                  }
                                });
                                return errors;
                              };
                              const errorss = validateFields(newData);
                              if (Object.keys(errorss).length === 0) {
                                setChecked((prev) => ({ check: !prev.check }));
                                setLoader(true);

                                const postData = await PatchApi(
                                  `/energy_need/${state.needId}/`,
                                  {
                                    billing_address: newData,
                                  }
                                );
                                if (
                                  postData.status === 200 ||
                                  postData.status === 201
                                ) {
                                  // const postEnergy = await getApi(
                                  //   `energy_consumption/form/${state.needId}/calculate_energy_consumption/`
                                  // );
                                  const payData = await PostApi(
                                    `/payment/checkout/`,
                                    {
                                      energy_need_id: state.needId,
                                    }
                                  );
                                  setLoader(false);
                                  localStorage.setItem(
                                    "purchase_id",
                                    payData?.data?.data?.id
                                  );
                                  setUrl(payData?.data.data?.gateway_url);
                                } else {
                                  throw Error("api failed");
                                }
                              } else {
                                setErrors(errorss);
                                return;
                              }
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                  <div>
                    <p
                      style={{
                        margin: "0px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        marginBottom: "5px",
                      }}
                    >
                      {needLanguage.i_agree_text}
                    </p>{" "}
                    <p
                      style={{
                        margin: "5px 0px",
                        fontSize: "14px ",
                        color: "#d32f2f",
                      }}
                    >
                      {errors.check}
                    </p>
                    <a
                      style={{
                        margin: "0px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        textDecoration: "underline",
                        color: "#22A156",
                      }}
                      href="https://greenox-group.de/agb-energieausweis/"
                      target="_blank"
                    // className={styles.terms}
                    >
                      {needLanguage.terms_conditions}
                    </a>
                    <br />
                    <a
                      style={{
                        margin: "0px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        textDecoration: "underline",
                        color: "#22A156",
                      }}
                      href="https://greenox-group.de/datenschutz/"
                      target="_blank"
                    // className={styles.terms}
                    >
                      {needLanguage.privacy_policy}
                    </a>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #22A156",
                }}
              >
                <p style={{ fontWeight: "900" }}>{needLanguage.total}</p>
                <div>
                  <p style={{ marginBottom: "4px", textAlign: "right" }}>
                    <b>{breakdown.total} &#8364;</b>
                  </p>
                  <p style={{ margin: "4px 0px" }}>
                    ({needLanguage.including})
                  </p>
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <Button
                  style={{ marginTop: "10px", width: "100%" }}
                  variant="contained"
                  onClick={() => {
                    // handleSubmit(8, "next")
                    const validateFields = (object) => {
                      const errors = {};
                      if (checked.check === false) {
                        errors.check = needLanguage?.proceed;
                      }
                      return errors;
                    };
                    const errorss = validateFields();
                    if (Object.keys(errorss).length === 0) {
                    } else {
                      setErrors(errorss);
                      return;
                    }
                    window.open(url, "_self").focus();
                  }}
                  sx={{
                    padding: "12px 25px",
                    fontWeight: "900",
                    borderRadius: "10px",
                    background:
                      " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                    boxShadow: "none",
                    color: "white",
                    "&:disabled": {
                      background: "gray",
                      color: "#ccc",
                    },
                  }}
                  disabled={loader}
                >
                  {loader && (
                    <CircularProgress
                      size={25}
                      style={{ marginRight: "20px" }}
                    />
                  )}{" "}
                  {needLanguage.order_now}
                </Button>
              </div>
            </div>
          )}
        </div>
        {/* <NavButton
          handleSubmit={handleSubmit}
          show={false}
          showPrint={!isCertificate}
          response={response}
        /> */}
        {pop && (
          <PopUpInfo
            handleClose={() => setPop(false)}
            open={pop}
            data={infoText}
          />
        )}
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        show={false}
        showPrint={!isCertificate}
        response={response}
      />
    </>
  );
}

export default Step8;

const object = {
  billing_address: {
    order_type: 1,
    first_name: "dsd",
    last_name: "dsd",
    phone: "9146917230",
    email: "kiratwad@gmail.com",
    postcode: "12345",
    street: "sa",
    location: "sas",
  },
};

const orderType = [
  {
    title: consumCertEngText.private_owners,
    german_title: consumCertGerText.private_owners,
    id: 1,
  },
  {
    title: consumCertEngText.commercial,
    german_title: consumCertGerText.commercial,
    id: 2,
  },
  {
    title: consumCertEngText.commercial_ustId,
    german_title: consumCertGerText.commercial_ustId,
    id: 3,
  },
];
